import { Box, Button, Grid, Typography } from "@mui/material";
import PowerPointSlide from "../../Reuseables/PowerPointSlide";
import OverallBarChart from "./OverallBarChart";
import { PercentageHistogramChart } from "./PercentageHistogramChart.js.jsx";
import { LoadsRadarChart } from "./LoadsRadarChart.jsx";
import { Margin, usePDF } from "react-to-pdf";
import { useApplicationContext } from "../../ContextProviders/ApplicationContext.js";
import { ActivityData } from "../../../types/chartData";
import { useOrganizationContext } from "../../ContextProviders/OrganizationContext";

type GeneratePDFPageProps = {
  props: any;
};

export default function GeneratePDFPage({ props }: GeneratePDFPageProps) {
  const { showLoading, stopLoading } = useApplicationContext();
  const { activeWorkspace } = useOrganizationContext();
  const getDate = (date: string) => {
    const today = new Date(date);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    } as Intl.DateTimeFormatOptions;
    return today.toLocaleDateString(undefined, options); // TODO pass current locale
  };

  const padToTwoDigits = (number: number) => {
    return number.toString().padStart(2, "0");
  };
  const { toPDF, targetRef } = usePDF({
    method: "save",
    filename: `${props.data.projectCode}.pdf`,
    page: {
      format: [338.67, 190.5],
      margin: Margin.NONE,
      orientation: "landscape",
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break,
    // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {},
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        // default is 'image/jpeg' for better size performance
        // mimeType: "image/jpeg",
        // qualityRatio: 1,
      },
    },
  });

  const download = () => {
    showLoading("");
    toPDF();
    setTimeout(stopLoading, 6000);
  };

  var activities = props.data.activities.filter(
    (a: ActivityData) => a.average != null
  );

  const backVestimg =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_backvest.jpg"
    );

  const logo =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/precure_logo_horizontal.png"
    );

  const reportApp =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_app.jpg"
    );
  const reportApp2 =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_app2.png"
    );
  const reportDashboard =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_dashboard.jpeg"
    );

  const reportMikkel =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_mikkel.jpg"
    );

  const reportSomedata =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_somedata.png"
    );
  const reportElbow =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/report_elbow.png"
    );

  const reportThanks1 =
    "https://corsproxy.io/?url=" +
    encodeURIComponent(
      "https://precure-cdn.azureedge.net/files/mli-interface/reportThanks1.png"
    );
  return (
    <>
      <Button variant="contained" onClick={download}>
        Download PDF
      </Button>

      <Box ref={targetRef} sx={{ minWidth: "33.867cm", maxWidth: "33.867cm" }}>
        {/* SLIDE 1  */}
        <PowerPointSlide>
          <Grid container sx={{ flexGrow: 1, position: "relative" }}>
            <Grid item xs sx={{}}>
              <Box
                padding={5}
                sx={{
                  flex: 1,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img src={logo} alt="Precure logo" />
                </Box>
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="h3"
                  fontWeight="bold"
                >
                  MLI Feedback Report
                </Typography>

                <Typography textAlign={"center"} color="black" variant="h4">
                  {activeWorkspace.displayName}
                </Typography>
                <Typography textAlign={"center"} color="black" variant="h4">
                  {props.selectedProject.projectName}
                </Typography>
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="caption"
                >
                  {getDate(props.startDate)} - {getDate(props.endDate)}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "white", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                  overflow: "hidden",
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    objectFit: "contain", // Scale image to fit inside circle
                    width: "130%", // Adjust width as needed
                  }}
                  src={backVestimg}
                  alt="app"
                />
              </Box>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "#7267AB", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                }}
              >
                {/* Placeholder content to ensure the background color is visible */}
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="body1"
                ></Typography>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "#CF3A19", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                }}
              >
                {/* Placeholder content to ensure the background color is visible */}
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="body1"
                ></Typography>
              </Box>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "6",
                  backgroundColor: "white", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              >
                <img height={"90%"} width={"70%"} src={reportApp} alt="app" />
                {/* Placeholder content to ensure the background color is visible */}
              </Box>
            </Grid>
            <Box
              sx={{
                position: "absolute",
                top: "55%",
                left: "55%",
                transform: "translate(0, -50%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "3",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="140"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="22"
                />
              </svg>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: "45%",
                left: "68%",
                transform: "translate(0, -50%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "4",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="40"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="15"
                />
              </svg>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: "0%",
                left: "75%",
                transform: "translate(0, -50%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "4",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="140"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="25"
                />
              </svg>
            </Box>
          </Grid>
        </PowerPointSlide>

        {/* SLIDE 2  */}
        <PowerPointSlide>
          <Grid container sx={{ flexGrow: 1 }}>
            <Grid item xs={3}>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "#3DA6D3", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              >
                {/* Placeholder content to ensure the background color is visible */}
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="body1"
                ></Typography>
              </Box>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "5",
                  backgroundColor: "white", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              >
                <img
                  style={{ objectFit: "contain", width: "90%" }}
                  src={reportDashboard}
                  alt="app"
                />
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "white", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                  overflow: "hidden", // Ensure content does not overflow
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    objectFit: "contain", // Scale the image to cover the box, cropping as needed
                    height: "120%",
                    transform: "translate(0,10%)",
                  }}
                  src={reportThanks1}
                  alt="app"
                />
              </Box>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "#D3DA4E", // Change this to your desired color
                  height: "50%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              >
                {/* Placeholder content to ensure the background color is visible */}
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="body1"
                ></Typography>
              </Box>
            </Grid>

            <Grid item xs>
              <Box>
                <Typography
                  textAlign={"center"}
                  marginTop={5}
                  variant="h4"
                  color="black"
                >
                  Index
                </Typography>
                <Box
                  padding={5}
                  height={"100%"}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignContent: "center",
                  }}
                  color="black"
                >
                  <Box height={100} width={"50%"}>
                    <Typography
                      textAlign={"center"}
                      fontWeight={"bold"}
                      variant="h4"
                    >
                      {padToTwoDigits(1)}
                    </Typography>
                    <Typography textAlign={"center"}>Introduction</Typography>
                  </Box>

                  <Box height={100} width={"50%"}>
                    <Typography
                      textAlign={"center"}
                      fontWeight={"bold"}
                      variant="h4"
                    >
                      {padToTwoDigits(2)}
                    </Typography>
                    <Typography textAlign={"center"}>
                      Overall results
                    </Typography>
                  </Box>
                  {activities.slice(1).map((a: ActivityData, i: number) => {
                    return (
                      <Box key={a.activityName} height={100} width={"50%"}>
                        <Typography
                          textAlign={"center"}
                          fontWeight={"bold"}
                          variant="h4"
                        >
                          {padToTwoDigits(i + 3)}
                        </Typography>
                        <Typography textAlign={"center"}>
                          {a.activityName}
                        </Typography>
                      </Box>
                    );
                  })}
                  <Box width={"50%"} height={100}>
                    <Typography
                      textAlign={"center"}
                      fontWeight={"bold"}
                      variant="h4"
                    >
                      {padToTwoDigits(activities.length + 3)}
                    </Typography>
                    <Typography textAlign={"center"}>Summary</Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Box
              sx={{
                position: "absolute",
                top: "0%",
                left: "10%",
                transform: "translate(0, 175%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "4",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="140"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="20"
                />
              </svg>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: "0%",
                left: "0%",
                transform: "translate(-50%, 130%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "4",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="140"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="25"
                />
              </svg>
            </Box>
          </Grid>
        </PowerPointSlide>
        {/* SLIDE 3  */}
        <PowerPointSlide>
          <Grid container sx={{ flexGrow: 1 }}>
            <Grid item xs>
              <Typography
                color="black"
                textAlign={"center"}
                marginTop={5}
                variant="h4"
              >
                Introduction
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "5",
                  backgroundColor: "white", // Change this to your desired color
                  height: "40%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "flex-end", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              >
                <img
                  width={"85%"}
                  height={"85%"}
                  src={reportMikkel}
                  alt="app"
                />
              </Box>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "#CF3A19", // Change this to your desired color
                  height: "60%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              ></Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "2",
                  backgroundColor: "#5BBFAC", // Change this to your desired color
                  height: "40%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                  zIndex: "3",
                  backgroundColor: "#CF3A19", // Change this to your desired color
                  height: "60%", // Ensure it has height to display the background color
                  display: "flex", // Enable flexbox
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                  overflow: "visible", // Allow overflow
                }}
              >
                {/* Placeholder content to ensure the background color is visible */}
                <img
                  style={{
                    position: "relative",
                    transform: "translate(-50%, 0)",
                    zIndex: "5",
                  }}
                  width={"100%"}
                  height={"100%"}
                  src={reportElbow}
                  alt="app"
                />
              </Box>
            </Grid>
            <Box
              sx={{
                position: "absolute",
                top: "0%",
                left: "28%",
                transform: "translate(50%, 275%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "4",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="180"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="28"
                />
              </svg>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: "25%",
                left: "12%",
                transform: "translate(50%, 275%)",
                pointerEvents: "none", // Ensure the annulus does not interfere with other elements
                zIndex: "4",
              }}
            >
              <svg width="600" height="600">
                <circle
                  cx="300"
                  cy="300"
                  r="70"
                  fill="none"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="25"
                />
              </svg>
            </Box>
          </Grid>
        </PowerPointSlide>
        {/* SLIDE 4  */}
        <PowerPointSlide>
          <Typography
            paddingLeft={3}
            sx={{ backgroundColor: "grey" }}
            color="white"
            textAlign={"start"}
            variant="h4"
            marginTop={5}
          >
            {"Overall"}
          </Typography>

          <Grid
            container
            direction={"column"}
            sx={{ flexGrow: 1 }}
            marginBottom={5}
            marginLeft={10}
            marginRight={10}
          >
            <Grid item xs>
              <Grid container marginTop={5}>
                <Grid item xs={3} alignContent={"top"}>
                  <OverallBarChart
                    height={220}
                    average={props.data.activities[0]}
                    selection={"Overall"}
                    attribute={"MLI"}
                  />
                </Grid>
                <Grid item xs>
                  <PercentageHistogramChart
                    height={243}           
                    data1={props.data.activities[0]}
                    selection={"Overall"}
                    attribute={"MLI"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography fontWeight={"bold"} marginLeft={5}>
                    Average TP MLI: {props.data.activities[0].average.mli.toFixed(1)}{" "}
                    / Average Pain score:{" "}
                    {props.data.activities[0].average.pain.toFixed(1)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs alignItems={"top"}>
              <Grid container>
                <Grid item xs>
                  <LoadsRadarChart
                    height={320}
                    selection={"Overall"}
                    deviceType={props.data.deviceType}
                    data1={props.data.activities[0]}
                    pc1={props.data.projectCode}
                  />
                </Grid>
                <Grid item xs>
                  <Box
                    sx={{
                      flex: 1,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography fontWeight={"bold"} marginLeft={5}>
                      Risk contribution:
                    </Typography>
                    <Typography
                      fontWeight={"bold"}
                      marginLeft={5}
                      marginBottom={10}
                    >
                      Conclusion:
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </PowerPointSlide>
        {/* Activity Slides */}
        {activities.slice(1).map((a: ActivityData) => (
          <PowerPointSlide key={a.activityName}>
            <Typography
              paddingLeft={3}
              sx={{ backgroundColor: "#5BBFAC" }}
              color="white"
              textAlign={"start"}
              variant="h4"
              marginTop={5}
            >
              {a.activityName}
            </Typography>
            <Grid
              container
              direction={"column"}
              sx={{ flexGrow: 1 }}
              marginBottom={5}
              marginLeft={10}
              marginRight={10}
            >
              <Grid item xs>
                <Grid container alignItems={"top"} marginTop={5}>
                  <Grid item xs={3}>
                    <OverallBarChart
                      height={220}
                      average={a.average}
                      selection={a.activityName}
                      attribute={"MLI"}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <PercentageHistogramChart
                      height={243}
                      // max={props.data.overall.usersHistogram.numUsers} TODO we dont need this right?
                      data1={a.percentageHistogram}
                      // projectCode={props.data.projectCode}
                      selection={a.activityName}
                      attribute={"MLI"}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"} marginLeft={5}>
                      Average TP MLI: {a.average?.mli.toFixed(1)} / Average Pain
                      score: {a.average?.pain.toFixed(1)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs alignItems={"top"}>
                <Grid container>
                  <Grid item xs>
                    <LoadsRadarChart
                      height={320}
                      selection={"Overall"}
                      deviceType={props.data.deviceType}
                      data1={a.deviceLoads}
                      pc1={props.data.projectCode}
                    />
                  </Grid>
                  <Grid item xs>
                    <Box
                      sx={{
                        flex: 1,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography fontWeight={"bold"} marginLeft={5}>
                        Risk contribution:
                      </Typography>
                      <Typography
                        fontWeight={"bold"}
                        marginLeft={5}
                        marginBottom={10}
                      >
                        Conclusion:
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </PowerPointSlide>
        ))}
        {/* Thank you slide */}

        <PowerPointSlide>
          <Grid container sx={{ flexGrow: 1 }}>
            <Grid item xs sx={{}}>
              <Box
                padding={5}
                sx={{
                  flex: 1,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img src={logo} alt="Precure logo" />
                </Box>
                <Typography
                  textAlign={"center"}
                  color="black"
                  variant="h2"
                  fontWeight={"bold"}
                >
                  Thank you
                </Typography>

                <Typography textAlign={"center"} color="black" variant="h4">
                  As always, we are open for questions.
                </Typography>
                <Typography textAlign={"center"} color="black" variant="h4">
                  sw@precure.dk
                </Typography>
              </Box>
            </Grid>
            <Box
              width="50%"
              height="100%"
              sx={{
                position: "relative", // Positioning context
                transform: "translate(0, 10%)", // Adjust for exact centering
              }}
            >
              <Box
                width="100%"
                height="100%"
                sx={{
                  width: "100%",
                  height: "100%", // Initially setting height to 0
                  paddingBottom: "100%", // Maintain aspect ratio as a percentage of width
                  backgroundColor: "#5BBFAC", // Example background color
                  borderRadius: "50%", // Make it circular
                  position: "relative", // Positioning context
                  overflow: "hidden", // Ensure content does not overflow
                }}
              >
                {/* Image positioned absolutely */}
                <img
                  src={reportThanks1}
                  style={{
                    position: "absolute",
                    top: "50%", // Center image vertically
                    left: "70%", // Center image horizontally
                    transform: "translate(-50%, -50%)", // Adjust for exact centering
                    height: "100%", // Adjust width as needed
                    objectFit: "contain", // Scale image to fit inside circle
                  }}
                />
              </Box>
              {/* Image positioned absolutely */}
              <img
                src={reportApp2}
                style={{
                  position: "absolute",
                  top: "40%", // Center image vertically
                  left: "20%", // Center image horizontally
                  transform: "translate(-50%, -50%)", // Adjust for exact centering
                  height: "75%", // Adjust width as needed
                  objectFit: "contain", // Scale image to fit inside circle
                }}
              />
              {/* Image positioned absolutely */}
              <img
                src={reportSomedata}
                style={{
                  position: "absolute",
                  top: "75%", // Center image vertically
                  left: "70%", // Center image horizontally
                  transform: "translate(-50%, -50%)", // Adjust for exact centering
                  objectFit: "contain", // Scale image to fit inside circle
                  width: "60%", // Adjust width as needed
                }}
              />
            </Box>
          </Grid>
        </PowerPointSlide>
      </Box>
    </>
  );
}
